import PropTypes from "prop-types";
// material
import { Box, Typography, Stack } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";

// ----------------------------------------------------------------------

DeliveryQuoteBanner.propTypes = {
  isPickup: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  deliveryDetails: PropTypes.object,
  sx: PropTypes.object,
};

export default function DeliveryQuoteBanner({
  isPickup = false,
  deliveryDetails = null,
  sx = {},
}) {
  const theme = useTheme();

  if (isPickup) {
    return null;
  }

  const warningColor = theme.palette.warning.darker || theme.palette.warning.dark;
  const warningBg = alpha(theme.palette.warning.main, 0.12);
  const borderLeftColor = theme.palette.warning.main;

  return (
    <Box
      sx={{
        mb: 3,
        p: 2,
        borderRadius: "8px",
        backgroundColor: warningBg,
        borderLeft: `4px solid ${borderLeftColor}`,
        borderTop: `1px solid ${alpha(theme.palette.warning.main, 0.2)}`,
        borderRight: `1px solid ${alpha(theme.palette.warning.main, 0.2)}`,
        borderBottom: `1px solid ${alpha(theme.palette.warning.main, 0.2)}`,
        ...sx,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <InfoOutlinedIcon
          sx={{
            color: warningColor,
            fontSize: 20,
            mt: "2px",
            flexShrink: 0,
          }}
        />
        <Box sx={{ flexGrow: 1 }}>
          <Typography
            variant="subtitle2"
            sx={{
              color: warningColor,
              fontWeight: 600,
              fontSize: "0.875rem",
              mb: deliveryDetails?.courier?.name || deliveryDetails?.estimated_days ? 0.5 : 0,
            }}
          >
            Customer has requested the cost of bringing/supplying the product to their address.
          </Typography>
          {deliveryDetails && (
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 0.5, sm: 2 }}
              sx={{ mt: 0.5 }}
            >
              {deliveryDetails.courier?.name && (
                <Stack direction="row" spacing={0.5} alignItems="center">
                  <LocalShippingOutlinedIcon
                    sx={{ fontSize: 16, color: warningColor }}
                  />
                  <Typography
                    variant="caption"
                    sx={{ color: warningColor, fontWeight: 500 }}
                  >
                    Method: {deliveryDetails.courier.name}
                  </Typography>
                </Stack>
              )}
              {deliveryDetails.estimated_days && (
                <Typography
                  variant="caption"
                  sx={{ color: warningColor, fontWeight: 500 }}
                >
                  Est. Delivery: {deliveryDetails.estimated_days}
                </Typography>
              )}
            </Stack>
          )}
        </Box>
      </Stack>
    </Box>
  );
}
